import { API_ENDPOINTS } from 'services/api';
import httpClient from 'services/httpClient';
import {
  MasterPlanDetailResponse,
  MasterPlanListParams,
  MasterPlanListResponse,
  UpdateMasterPlanPayload,
  MasterPlanRejectPayload,
  CreateMasterPlanResponse,
  MasterPlanListByGroupParams,
  MasterPlanListByGroupResponse,
  MasterPlanDetailByGroupResponse
} from 'types/dacum/masterPlan';
import {
  MasterPlanBranchedParams,
  MasterPlanBranchedResponse,
  MasterPlanOverviewParams,
  MasterPlanOverviewResponse,
  MasterPlanOverviewCourseResponse,
  MasterPlanOverviewJobBandResponse
} from 'types/dacum/masterPlanOverview';

export const masterPlanService = {
  getMasterPlanOverview: async (
    params: MasterPlanOverviewParams
  ): Promise<MasterPlanOverviewResponse> => {
    const response = await httpClient.get<MasterPlanOverviewResponse>(
      API_ENDPOINTS.DACUM.MASTERPLAN.OVERVIEW,
      {
        params
      }
    );
    return response.data;
  },
  getMasterPlanJobBandOverview: async (
    params: MasterPlanOverviewParams
  ): Promise<MasterPlanOverviewJobBandResponse> => {
    const response = await httpClient.get<MasterPlanOverviewJobBandResponse>(
      API_ENDPOINTS.DACUM.MASTERPLAN.JOBBAND_OVERVIEW,
      {
        params
      }
    );
    return response.data;
  },
  getMasterPlanBranchedOverview: async (
    params: MasterPlanBranchedParams
  ): Promise<MasterPlanBranchedResponse> => {
    const response = await httpClient.get<MasterPlanBranchedResponse>(
      API_ENDPOINTS.DACUM.MASTERPLAN.BRANCHED_OVERVIEW,
      {
        params
      }
    );
    return response.data;
  },
  getMasterPlanCourseOverview: async (
    params: MasterPlanOverviewParams
  ): Promise<MasterPlanOverviewCourseResponse> => {
    const response = await httpClient.get<MasterPlanOverviewCourseResponse>(
      API_ENDPOINTS.DACUM.MASTERPLAN.COURSE_OVERVIEW,
      {
        params
      }
    );
    return response.data;
  },
  getMasterPlanList: async (params: MasterPlanListParams): Promise<MasterPlanListResponse> => {
    const { jobFamily, ...otherParams } = params;
    const queryParams = {
      ...otherParams,
      ...(jobFamily && { search: jobFamily })
    };
    const response = await httpClient.get<MasterPlanListResponse>(
      API_ENDPOINTS.DACUM.MASTERPLAN.LIST,
      {
        params: queryParams
      }
    );
    return response.data;
  },
  getMasterPlanListByGroup: async (
    params: MasterPlanListByGroupParams
  ): Promise<MasterPlanListByGroupResponse> => {
    const response = await httpClient.get<MasterPlanListByGroupResponse>(
      API_ENDPOINTS.DACUM.MASTERPLAN.LIST_BY_GROUP,
      {
        params
      }
    );
    return response.data;
  },
  getMasterPlanDetail: async (params: {
    jobFamily: string;
    year: string;
    masterplanId?: string;
  }): Promise<MasterPlanDetailResponse> => {
    const response = await httpClient.get<MasterPlanDetailResponse>(
      API_ENDPOINTS.DACUM.MASTERPLAN.DETAIL,
      { params }
    );
    return response.data;
  },
  getMasterPlanDetailByGroup: async (params: {
    jobFamilyGroup: string;
    year: string;
    endYear?: string;
  }): Promise<MasterPlanDetailByGroupResponse> => {
    const response = await httpClient.get<MasterPlanDetailByGroupResponse>(
      API_ENDPOINTS.DACUM.MASTERPLAN.DETAIL_BY_GROUP,
      { params }
    );
    return response.data;
  },
  updateMasterPlan: async (payload: UpdateMasterPlanPayload): Promise<CreateMasterPlanResponse> => {
    const response = await httpClient.put<CreateMasterPlanResponse>(
      API_ENDPOINTS.DACUM.MASTERPLAN.UPDATE,
      payload
    );
    return response.data;
  },
  deleteMasterPlan: async (programId: string): Promise<CreateMasterPlanResponse> => {
    const response = await httpClient.delete<CreateMasterPlanResponse>(
      API_ENDPOINTS.DACUM.MASTERPLAN.DELETE(programId)
    );
    return response.data;
  },
  approveMasterPlan: async (programId: string): Promise<CreateMasterPlanResponse> => {
    const response = await httpClient.put<CreateMasterPlanResponse>(
      API_ENDPOINTS.DACUM.MASTERPLAN.APPROVE(programId)
    );
    return response.data;
  },
  rejectMasterPlan: async (payload: MasterPlanRejectPayload): Promise<CreateMasterPlanResponse> => {
    const response = await httpClient.put<CreateMasterPlanResponse>(
      API_ENDPOINTS.DACUM.MASTERPLAN.REJECT,
      payload
    );
    return response.data;
  }
};
